import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ServerService} from './ServerService';
import {ConfiguracaoNps, FiltroNps, ItemEnvioNps} from './nps.model';

@Injectable({providedIn: 'root'})
export class NpsService extends ServerService {
  constructor(protected http: HttpClient) {super(http);}
  private parametros(filtro: FiltroNps): any {
    const params: any = {};
    for (const chave of Object.keys(filtro)) if ((filtro as any)[chave] != null && (filtro as any)[chave] !== '') params[chave] = (filtro as any)[chave];
    return params;
  }
  painel(filtro: FiltroNps): Promise<any> {return this.obtenha('/nps/painel', this.parametros(filtro));}
  respostas(filtro: FiltroNps): Promise<any> {return this.obtenha('/nps/respostas', this.parametros(filtro));}
  envios(filtro: FiltroNps): Promise<any> {return this.obtenha('/nps/envios', this.parametros(filtro));}
  empresa(id: number): Promise<any> {return this.obtenha('/nps/empresas/' + id, {});}
  configuracao(): Promise<ConfiguracaoNps> {return this.obtenha('/nps/configuracao', {});}
  salveConfiguracao(dados: ConfiguracaoNps): Promise<ConfiguracaoNps> {return this.facaPut('/nps/configuracao', dados);}
  incorporeEmpresa(id: number, dados: any): Promise<any> {return this.facaPost('/nps/empresas/' + id + '/jornada', dados);}
  preferencias(id: number, dados: any): Promise<any> {return this.facaPut('/nps/empresas/' + id + '/preferencias', dados);}
  reserveEnvio(): Promise<ItemEnvioNps | null> {return this.facaPost('/nps/envios/reservar', {});}
  concluaEnvio(id: number, dados: any): Promise<any> {return this.facaPost('/nps/envios/' + id + '/concluir', dados);}
  reviseEnvio(id: number, dados: any): Promise<any> {return this.facaPost('/nps/envios/' + id + '/revisar', dados);}
  destinatario(id: number, dados: any): Promise<any> {return this.facaPut('/nps/pesquisas/' + id + '/destinatario', dados);}
  cancelePesquisa(id: number, dados: any): Promise<any> {return this.facaPost('/nps/pesquisas/' + id + '/cancelar', dados);}
}
